<script setup>

import { onMounted } from 'vue'
import { generateNumericInputPlaceholder, sanitizeNumericInput } from '@/libs/utils/questions/numeric.js'

const props = defineProps(['handleAnswer', 'compiledPoll', 'question'])
const answerValue = defineModel('answerValue');
const answerNote = defineModel('answerNote');

function handleInput() {
  if (answerValue.value !== null && answerValue.value.toString().trim() !== '') {
    if (props.handleAnswer !== null) {
      props.handleAnswer(props.question['reference'], answerValue.value.toString(), false, answerNote.value)
    }
  } else {
    if (props.handleAnswer !== null) {
      props.handleAnswer(props.question['reference'], null, false, answerNote.value)
    }
  }
}

onMounted(() => {
  props.compiledPoll['answers'].forEach(el => {
    if (el['questionReference'] === props.question['reference']) {
      if (el['note']) answerNote.value = el['note'];
      if (el['value']) {
        answerValue.value = el['value'];
      }
    }
  })

  if (props.handleAnswer) {
    props.handleAnswer(props.question['reference'], answerValue.value, false, answerNote.value);
  }
})
</script>

<template>
  <div class="pe-2">
    <label
      :for="'textQuestion' + question['id']"
      :class="'form-label' + (question.required ? ' fw-bold ' : '')"
    >
      {{ question.text }} {{ question.required ? '*' : '' }}
    </label>

    <input
      @change="handleInput"
      :disabled="handleAnswer === null"
      v-model="answerValue"
      :id="'textQuestion' + question['id']"
      class="form-control"
      type="number"
      :min="props.question.additionalProperties.range?.min"
      :max="props.question.additionalProperties.range?.max"
      :required="question.required"
      :name="question['id']"
      @keydown="sanitizeNumericInput($event, answerValue)"
      :placeholder="generateNumericInputPlaceholder(props.question.additionalProperties.range)"
    />

    <small v-if="question.helper" class="form-text">
      {{ question.helper }}
    </small>

    <div v-if="question.hasNote" class="pt-2">
      <div class="pe-2">
        <label :for="'noteQuestion'+question['id']" class="form-label">
          Note
        </label>
        <textarea @change="handleInput"
                  class="form-control" rows="2" placeholder="Inserisci note"
                  :id="'noteQuestion'+question['id']"
                  v-model="answerNote"
                  :disabled="!(compiledPoll['state'] !== 'filled' && handleAnswer !== null)"></textarea>
      </div>
    </div>
  </div>
</template>
